import React from 'react';
import { AlertCircle, DollarSign, Clock, Shield } from 'lucide-react';

const ProblemsWeSolve = () => {
  const problems = [
    {
      icon: AlertCircle,
      problem: 'Can\'t Visualize Your Ideas',
      solution: 'See your design in AR before spending money. Make changes instantly until it\'s perfect.',
    },
    {
      icon: Clock,
      problem: 'Costly Design Mistakes',
      solution: 'Avoid expensive changes and regrets. Test everything virtually before committing.',
    },
    {
      icon: DollarSign,
      problem: 'Unscrupulous Contractors',
      solution: 'Skip middlemen. Order directly from verified partners with transparent, fair pricing.',
    },
    {
      icon: Shield,
      problem: 'Unnecessary Additions & Hidden Costs',
      solution: 'Complete control and visibility. Know exactly what you\'re paying for, no surprises.',
    },
  ];

  return (
    <section className="relative py-32 px-6 md:px-[7.6923%]">
      {/* Grid background */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            'repeating-linear-gradient(0deg, transparent, transparent 1px, transparent 1px, transparent 7.6923%), repeating-linear-gradient(-90deg, #fff, #fff 1px, transparent 1px, transparent 7.6923%)',
          backgroundSize: '100% 100%',
          opacity: 0.03,
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-20">
          <h2
            className="text-4xl md:text-5xl lg:text-6xl font-semibold mb-6"
            style={{
              color: 'var(--text-primary)',
              letterSpacing: '-0.02em',
            }}
          >
            Stop Wasting Time and Money
          </h2>
          <p
            className="text-lg md:text-xl max-w-3xl mx-auto"
            style={{ color: 'var(--text-secondary)' }}
          >
            We solve the biggest problems homeowners face when renovating or building their dream home.
          </p>
        </div>

        {/* Problems grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {problems.map((item, index) => (
            <div
              key={index}
              className="glass p-8 rounded-3xl border-2 border-orange-200 hover:border-orange-400 transition-all duration-400 hover:shadow-xl"
            >
              <div className="mb-6">
                <item.icon size={48} color="#FF8000" strokeWidth={1.5} />
              </div>
              <h3
                className="text-2xl font-semibold mb-3"
                style={{ color: 'var(--text-primary)' }}
              >
                {item.problem}
              </h3>
              <p
                className="text-base"
                style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}
              >
                <span style={{ color: 'var(--brand-primary)' }}>Solution: </span>
                {item.solution}
              </p>
            </div>
          ))}
        </div>

        {/* Hero image */}
        <div className="relative overflow-hidden group">
          <img
            src="https://images.pexels.com/photos/18409678/pexels-photo-18409678.jpeg"
            alt="AR Home Visualization"
            className="w-full h-[500px] md:h-[600px] object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-70" />
          <div
            className="absolute inset-0 border-2 transition-opacity duration-400 opacity-0 group-hover:opacity-100"
            style={{ borderColor: 'var(--brand-primary)' }}
          />
          <div className="absolute bottom-12 left-12">
            <h3 className="text-3xl font-semibold mb-3 text-white">
              Take Control of Your Home Project
            </h3>
            <p className="text-xl text-gray-200">
              From idea to installation, all in one platform
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <a href="#register">
            <button className="bg-[#FF8000] text-black border-none rounded-2xl px-8 py-4 text-lg font-medium cursor-pointer transition-all duration-400 hover:bg-[rgba(0,255,209,0.1)] hover:text-[#FF8000] min-h-[56px] flex items-center justify-center gap-3 mx-auto">
              Register Your Interest
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProblemsWeSolve;
